import React from 'react';

import { Confirmation } from './Confirmation';

interface Props {
  onContinue: () => void;
  onCancel: () => void;
}

const info = (
  <div>
    <div>You currently have unsaved changes.</div>
    <div>Would you still like to exit?</div>
  </div>
);

export const DiscardConfirmation: React.FC<Props> = ({ onContinue, onCancel }) => (
  <Confirmation
    data-testid="delete-confirm"
    question="Are you sure?"
    info={info}
    primaryText="Yes"
    onPrimaryAction={onContinue}
    secondaryText="No"
    onSecondaryAction={onCancel}
  />
);
